'use memo'

import {
  ActivitiesApiException,
  type AutopilotTaskDto,
  useInvalidateUseGetAutopilotTasksForCampaign,
} from '@urbanx/agx.activities.client'
import { useToast } from '@urbanx/agx.ui-components2'

type WorkflowIdentity = Pick<AutopilotTaskDto, 'campaignId' | 'contractId'>

interface WorkflowConflictRecovery {
  restore?: () => void
  refresh?: () => void | Promise<void>
}

export const isWorkflowConcurrencyError = (
  error: unknown
): error is ActivitiesApiException =>
  ActivitiesApiException.isActivitiesApiException(error) && error.status === 409

export const useWorkflowConcurrencyError = () => {
  const invalidateTasks = useInvalidateUseGetAutopilotTasksForCampaign()
  const { pushToast } = useToast()

  return async (
    error: unknown,
    workflow: WorkflowIdentity,
    recovery: WorkflowConflictRecovery = {}
  ) => {
    if (!isWorkflowConcurrencyError(error)) return false

    recovery.restore?.()

    if (workflow.campaignId) {
      await invalidateTasks(workflow.campaignId, workflow.contractId)
    }

    await recovery.refresh?.()

    pushToast({
      type: 'error',
      message: 'This workflow changed. Review the latest tasks and try again.',
    })

    return true
  }
}
